import { render, staticRenderFns } from "./ItemFilterImage.vue?vue&type=template&id=525c6180&scoped=true&"
import script from "./ItemFilterImage.vue?vue&type=script&lang=ts&"
export * from "./ItemFilterImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c6180",
  null
  
)

export default component.exports